import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {Municipio} from "./municipio";
import {NotaFiscal} from "./nota.fiscal";
import {BilheteNotaPremiada} from "./bilhete.nota.premiada";

@JacksonType("BilheteNotaPremiadaDependencia")
@JsonIdentityInfo()
export class BilheteNotaPremiadaDependencia extends SonnerBaseEntity {

  id: number;

  @JacksonType("Municipio")
  municipio: Municipio;

  @JacksonType("NotaFiscal")
  notaFiscal:NotaFiscal;

  valorFixoUtilizado: number;

  valorUtilizado: number;

  @JacksonType("BilheteNotaPremiada")
  bilhete: BilheteNotaPremiada;

}
